// cms/pages/PopupMgr.jsx
import React, { useEffect, useMemo, useState } from "react";
import { apiAxios, apiAxiosMulti } from "../api/mockApi";
import ConfirmModal from "../components/ConfirmModal";
import NewWindow from "../components/NewWindow";
import RichEditor from "../components/RichEditor";
import AttachmentBox from "../components/AttachmentBox";

const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo") || "{}");
// =========================
// 정책 상수
// =========================
const POPUP_POLICY = {
  DEFAULT_WIDTH: 600,
  DEFAULT_HEIGHT: 520,
  MARGIN_RIGHT: 50,
  MARGIN_BOTTOM: 30,
};

/* =========================
   유틸
========================= */
// HTML에서 첫 번째 <img src> 추출
const firstImgSrc = (html = "") => {
  const m = html.match(/<img[^>]+src=["']([^"']+)["']/i);
  return m ? m[1] : "";
};
// HTML → 텍스트 요약
const stripHtml = (s = "") =>
  (s || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();

// 사람이 읽기 좋은 파일 크기 표기
function formatBytes(bytes) {
  if (!bytes && bytes !== 0) return "";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0,
    n = Number(bytes);
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

/* =========================
   썸네일: 이미지 없으면 텍스트 요약
========================= */
function ThumbPreview({ thumb, title, content }) {
  if (thumb) {
    return (
      <img
        src={thumb}
        alt="thumb"
        style={{
          width: 230,
          height: 150,
          objectFit: "cover",
          objectPosition: "top",
          borderRadius: 6,
        }}
      />
    );
  }
  const summary = (stripHtml(content || "").slice(0, 40) || "(내용 없음)");
  return (
    <div
      className="thumb-fallback"
      style={{
        width: 230,
        height: 150,
        borderRadius: 6,
        background: "linear-gradient(135deg, #EEF2FF, #F8FAFC)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: 6,
        overflow: "hidden",
        border: "1px solid #e5e7eb",
      }}
      title="이미지 없음 – 텍스트 미리보기"
    >
      <div style={{ fontSize: 14, fontWeight: 700 }} className="text-truncate">
        {title || "제목 없음"}
      </div>
      <div
        style={{
          fontSize: 10,
          color: "#6b7280",
          lineHeight: 1.2,
          maxHeight: 28,
          overflow: "hidden",
        }}
      >
        {summary}
      </div>
    </div>
  );
}

/* =========================
   서버 호출 (수정/등록/삭제)
========================= */
// async function updatePopup(patch, mod = false) {
//   let url = "/scms/api/pop/updatePopList.do";
//   if (mod) {
//     url = "/scms/api/pop/insertPopList.do";
//   }
//   const info = JSON.stringify(patch);
//   try {
//     apiAxios(url, info, function (res) {
//       // alert(res.message);
//       // window.location.reload();
//       const ok =
//         res?.apiRes === "Y" ||
//         res?.success === true ||
//         res?.status === "OK";
//       const msg =
//         res?.message ??
//         res?.msg ??
//         res?.resultMsg ??
//         (ok ? "저장되었습니다." : "저장에 실패했습니다.");

//       alert(msg);
//       if (ok) window.location.reload();
//       else console.error("[PopupMgr] save failed:", res);
//     });
//   } catch (e) {
//     console.error(e);
//     alert("요청 중 오류가 발생했습니다.");
//   }
// }

// async function deletePost(row) {
//   const url = "/scms/api/bbs/deleteBoardArticle.do";
//   const body = JSON.stringify({
//     NTT_ID: row.NTT_ID,
//     BBS_ID: row.BBS_ID,
//     LAST_REGISTER_ID: userInfo.uniqId,
//   });

//   apiAxios(url, body, function (res) {
//     alert(res.message);
//     window.location.reload();
//   });
// }
async function updatePopup(patch, files = [], isCreate = false) {
  let url = isCreate ? "/scms/api/pop/insertPopList.do"
                    : "/scms/api/pop/updatePopList.do";

  const fd = new FormData();
  // 서버가 기대하는 구조: info(JSON) + fileList[]
  fd.append("info", new Blob([JSON.stringify(patch)], { type: "application/json" }));
  (Array.isArray(files) ? files : []).forEach(f => {
    // AttachmentBox가 {file: File, ...} 형태라면 f.file, 이미 File이면 f
    fd.append("fileList", f?.file ?? f);
  });

  apiAxiosMulti(url, fd, (res) => {
    const ok =
      res?.apiRes === "Y" ||
      res?.success === true ||
      res?.status === "OK" ||
      res?.resultCode === "0000" ||
      res?.code === "SUCCESS";
    // const msg = res?.message ?? res?.resultMsg ?? (ok ? "저장되었습니다." : "저장에 실패했습니다.");
      let msg = res?.message ?? res?.resultMsg ?? "";
      // 서버 기본 영문 메시지 보정
      if (!msg) msg = ok ? "저장되었습니다." : "저장에 실패했습니다.";
      if (/successfully inserted/i.test(msg)) msg = "저장되었습니다.";
      if (/successfully updated/i.test(msg))  msg = "수정되었습니다.";
      if (/deleted/i.test(msg))               msg = "삭제되었습니다.";
    alert(msg);
    // if (ok) window.location.reload();
    // else console.error("[PopupMgr] save failed:", res);
    return ok;
  });
}

// 삭제: JSON 그대로(body는 JSON.stringify) 사용 + ok 반환
// 삭제: JSON 그대로(body는 JSON.stringify) 사용 + ok 반환
async function deletePopup(row) {
  const url = "/scms/api/pop/deletePopList.do";

  // 서버가 실키로 쓰는 값 결정: CONT_ID > ID 순
  const key =
    row?._SRC?.CONT_ID ??
    row?.CONT_ID ??
    row?._SRC?.ID ??
    row?.ID;

  if (!key) {
    alert("삭제할 키(CONT_ID/ID)가 없습니다.");
    return false;
  }

  const body = JSON.stringify({
    CONT_ID: key,                                 // 대부분 CONT_ID 키로 처리
    ID: row?._SRC?.ID ?? row?.ID ?? undefined,    // 혹시 ID도 쓰면 같이 전달
    UNIQ_ID:          (userInfo?.uniqId || userInfo?.uniqID || ""),
    LAST_REGISTER_ID: (userInfo?.uniqId || userInfo?.uniqID || ""),
    FRST_REGISTER_ID: (userInfo?.uniqId || userInfo?.uniqID || ""),
  });
  console.log(body);
  return new Promise((resolve) => {
    apiAxios(url, body, (res) => {
      const ok =
        res?.apiRes === "Y" ||
        res?.success === true ||
        res?.status === "OK" ||
        res?.resultCode === "0000" ||
        res?.code === "SUCCESS";

      let msg = res?.message ?? res?.resultMsg ?? "";
      if (!msg) msg = ok ? "삭제되었습니다." : "삭제에 실패했습니다.";
      if (/deleted/i.test(msg)) msg = "삭제되었습니다.";
      alert(msg);

      resolve(ok);
    });
  });
}


/* ========================= 상세 패널 ========================= */
function DetailPanel({ item, onClose, onSaved, onDeleted, portalTarget }) {
  React.useEffect(() => {
    // if (item && !item.contentHtml && item.content) {
    //   setForm((f) => ({ ...f, contentHtml: item.content }));
    // }
    // if (item && typeof item.autoThumb === "undefined") {
    //   setForm((f) => ({ ...f, autoThumb: true }));
    // }

    // ★ 원본(row._src) 값을 폼필드로 매핑해서 편집 가능하게
    if (item?._SRC) {
      const s = item._SRC;
      const yn = (v) => (String(v || "").toUpperCase() === "Y" ? "Y" : "N");
      setForm((f) => ({
        ...f,
        // 제목/기간/내용 (폼 상태는 소문자 유지)
        TITLE: item.TITLE || "",
        CONTENT_HTML: item.CONTENT_HTML || "",
        START: item.START || "",
        END: item.END || "",
        // 표시/배치 설정
        WIN_STYLE: s.WIN_STYLE ?? f.WIN_STYLE ?? "",
        VIEW_YN: yn(s.VIEW_YN ?? f.VIEW_YN ?? "Y"),
        USE_AT: yn(s.USE_AT ?? f.USE_AT ?? "Y"),
        POS_LEFT: Number(s.POS_LEFT ?? f.POS_LEFT ?? 40),
        POS_TOP: Number(s.POS_TOP ?? f.POS_TOP ?? 60),
        SIZE_WIDTH: Number(s.SIZE_WIDTH ?? f.SIZE_WIDTH ?? 500),
        SIZE_HEIGHT: Number(s.SIZE_HEIGHT ?? f.SIZE_HEIGHT ?? 580),
        // 등록/수정일
        REG_DT: s.FRST_PNTTM || f.REG_DT || "",
      }));
    }
  }, [item]);
  // item은 리스트 행이며 _src에 API 원본이 들어있음
  const init = item
    ? {
      TITLE: item.TITLE || "",
      CONTENT_HTML: item.CONTENT_HTML || "",
      START: item.START || "",
      END: item.END || "",
      visible: true,
      priority: 1,
      THUMB: item.THUMB || "",
      autoThumb: true,
      REG_DT: item._SRC?.FRST_PNTTM || "",
      WIN_STYLE: item._SRC?.WIN_STYLE ?? "",
      VIEW_YN: (String(item._SRC?.VIEW_YN || "Y").toUpperCase() === "Y" ? "Y" : "N"),
      USE_AT: (String(item._SRC?.USE_AT || "Y").toUpperCase() === "Y" ? "Y" : "N"),
      POS_LEFT: Number(item._SRC?.POS_LEFT ?? 40),
      POS_TOP: Number(item._SRC?.POS_TOP ?? 60),
      SIZE_WIDTH: Number(item._SRC?.SIZE_WIDTH ?? 500),
      SIZE_HEIGHT: Number(item._SRC?.SIZE_HEIGHT ?? 580),
    }
  : {
      // ← 신규 기본값(소문자 폼 키 유지)
      TITLE: "",
      CONTENT_HTML: "",
      START: "",
      END: "",
      visible: true,
      priority: 1,
      THUMB: "",
      autoThumb: true,
      REG_DT: "",
      WIN_STYLE: "",
      VIEW_YN: "Y",
      USE_AT: "Y",
      POS_LEFT: 40,
      POS_TOP: 60,
      SIZE_WIDTH: 500,
      SIZE_HEIGHT: 580,
    };

  const [form, setForm] = useState(init);
  const [edit, setEdit] = useState(!item);
  const [file, setFile] = useState(null);
  const [askDelete, setAskDelete] = useState(false);
  const [errs, setErrs] = useState({});               // ← 에러 상태 추가
  
  const titleRef = React.useRef(null);
  const startRef = React.useRef(null);
  const endRef   = React.useRef(null);
  const editorRef= React.useRef(null);

  const set = (k, v) => setForm({ ...form, [k]: v });

  const stripHtml = (s = "") => (s || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  const validate = () => {
    const e = {};
    const title = (form.TITLE || "").trim();
    const start = (form.START || "").trim();
    const end   = (form.END   || "").trim();
    const contentText = stripHtml(form.CONTENT_HTML || "");

    if (!title) e.TITLE = "제목은 필수입니다.";
    if (!start) e.START = "시작일은 필수입니다.";
    if (!end)   e.END   = "종료일은 필수입니다.";
    if (start && end && start > end) e.END = "종료일은 시작일 이후여야 합니다.";
    if (!contentText) e.CONTENT_HTML = "내용은 필수입니다.";

    setErrs(e);

    // 첫 에러로 포커스
    if (e.TITLE && titleRef.current) titleRef.current.focus();
    else if (e.START && startRef.current) startRef.current.focus();
    else if (e.END && endRef.current) endRef.current.focus();
    else if (e.CONTENT_HTML && editorRef.current) editorRef.current.scrollIntoView({behavior:"smooth",block:"center"});

    return Object.keys(e).length === 0;
  };

  const save = async () => {
    if (!validate()) return; 
    // 간단 유효성 체크
    const w = Math.max(240, Number(form.SIZE_WIDTH || 0));
    const h = Math.max(200, Number(form.SIZE_HEIGHT || 0));
    const toYmd8 = (s) => (s || "").replaceAll("-", ""); // "2025-11-10" -> "20251110"

    const payload = {
      // 기본 키(수정일 때만 존재)
      ID: item?._SRC?.ID ?? item?.ID ?? undefined,
      CONT_ID: item?._SRC?.CONT_ID ?? undefined,

      // 제목/내용/기간 → PopupBoard/서버 컬럼에 맞춤
      PMG_NM: form.TITLE || "",
      PMG_CN: form.CONTENT_HTML || "",
      // VIEW_ST: form.START || "",
      // VIEW_ED: form.END || "",
      VIEW_ST: toYmd8(form.START) || "",
      VIEW_ED: toYmd8(form.END)   || "",

      // 표시/배치/창형태
      WIN_STYLE: form.WIN_STYLE || "",      // ""(레이어) | "W"(새창)
      VIEW_YN: (form.VIEW_YN || "Y"),
      USE_AT: (form.USE_AT || "Y"),
      POS_LEFT: Number(form.POS_LEFT ?? 0),
      POS_TOP: Number(form.POS_TOP ?? 0),
      SIZE_WIDTH: w,
      SIZE_HEIGHT: h,

      // 작성자
      // UNIQ_ID: (userInfo?.uniqId || userInfo?.uniqID || ""),
      UNIQ_ID:           (userInfo?.uniqId || userInfo?.uniqID || ""),
      LAST_REGISTER_ID:  (userInfo?.uniqId || userInfo?.uniqID || ""),
      FRST_REGISTER_ID:  (userInfo?.uniqId || userInfo?.uniqID || ""),
    };

    // if (payload.ID) await updatePopup(payload);
    // else await updatePopup(payload, true);

    const isCreate = !payload.ID && !payload.CONT_ID;
    // await updatePopup(payload, file || [], isCreate);
    const ok = await updatePopup(payload, file || [], isCreate);
    if (ok) onSaved && onSaved(true);   // 성공시에만 콜백
    // onSaved && onSaved();
  };

  const Req = () => <span style={{color:"#dc3545", marginLeft:4}}>*</span>;
  return (
    <div style={{ minWidth: "860px" }}>
      <div className="win-toolbar">
        <span className="title">{item ? "팝업 상세" : "팝업 등록"}</span>
        <div className="d-flex gap-2">
          {item && !edit && (
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => setEdit(true)}
            >
              <i className="fa-regular fa-pen-to-square me-1"></i>수정
            </button>
          )}
          {!edit && item && (
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => setAskDelete(true)}
            >
              <i className="fa-regular fa-trash-can me-1"></i>삭제
            </button>
          )}
          <button className="btn btn-sm btn-secondary" onClick={onClose}>
            닫기
          </button>
          {edit && (
            <button type="button" className="btn btn-sm btn-primary" onClick={save}>
              <i className="fa-regular fa-floppy-disk me-1"></i>저장
            </button>
          )}
        </div>
      </div>

      <div className="win-body">
        <div className="row g-3 input-rounded">
          {/* 제목 */}
          <form>
            <label className="form-label">제목<Req /></label>
            {edit ? (
              <input
                ref={titleRef}
                className={`form-control ${errs.TITLE ? "is-invalid" : ""}`}
                value={form.TITLE}
                onChange={(e) => set("TITLE", e.target.value)}
              />
            ) : (
              <div className="form-control bg-light">{form.TITLE}</div>
            )}
            {errs.TITLE && <div className="invalid-feedback d-block">{errs.TITLE}</div>}
          </form>

          {/* 등록일/기간 */}
          <div
            className="data-wrap align-items-center"
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "5px",
              paddingRight: "18px",
            }}
          >
            <div className="col-md-4">
              <label className="form-label">시작일<Req /></label>
              {edit ? (
                <input
                  ref={startRef}
                  type="date"
                  className={`form-control ${errs.START ? "is-invalid" : ""}`}
                  value={form.START}
                  onChange={(e) => set("START", e.target.value)}
                />
              ) : (
                <div className="form-control bg-light">{form.START}</div>
              )}
              {errs.START && <div className="invalid-feedback d-block">{errs.START}</div>}
            </div>
            <div className="col-md-4">
              <label className="form-label">종료일<Req /></label>
              {edit ? (
                <input
                  ref={endRef}
                  type="date"
                  className={`form-control ${errs.END ? "is-invalid" : ""}`}
                  value={form.END}
                  onChange={(e) => set("END", e.target.value)}
                />
              ) : (
                <div className="form-control bg-light">{form.END}</div>
              )}
              {errs.END && <div className="invalid-feedback d-block">{errs.END}</div>}
            </div>
            <form className="col-md-4 ms-auto">
              <label className="form-label mb-1">등록/수정일</label>
              <input className="form-control" value={form.REG_DT} disabled />
            </form>
          </div>

          {/* 내용 - 에디터(이미지 첨부 포함) */}
          <div className="col-12" ref={editorRef}>
            <label className="form-label">내용<Req /></label>
            {edit ? (
              <RichEditor
                value={form.CONTENT_HTML || ""}
                onChange={(html) => set("CONTENT_HTML", html)}
                minHeight={260}
                placeholder="팝업 내용을 입력하세요 (이미지는 에디터의 이미지 버튼/붙여넣기/드래그로 첨부 가능)"
              />
            ) : (
              <div
                className="form-control bg-light"
                style={{ minHeight: 140, whiteSpace: "pre-line" }}
                dangerouslySetInnerHTML={{ __html: form.CONTENT_HTML || "" }}
              />
            )}
            {errs.CONTENT_HTML && (
              <div className="invalid-feedback d-block">{errs.CONTENT_HTML}</div>
            )}
          </div>

          {/* 첨부파일 */}
          <div>
            <label className="form-label">첨부파일</label>
            {edit ? (
              <AttachmentBox files={file || []} onChange={(list) => setFile(list)} />
            ) : Array.isArray(file) && file.length > 0 ? (
              <ul className="list-group list-group-flush">
                {file.map((f, i) => (
                  <li
                    key={f.ID || `${f.FILE_NM}-${i}`}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <i className="fa-solid fa-paperclip text-secondary" />
                      {f.url ? (
                        <a
                          href={f.url}
                          target="_blank"
                          rel="noreferrer"
                          download={f.FILE_NM}
                          className="link-dark text-decoration-none"
                        >
                          {f.FILE_NM || `첨부파일_${i + 1}`}
                        </a>
                      ) : (
                        <span>{f.FILE_NM || `첨부파일_${i + 1}`}</span>
                      )}
                      {f.size != null && (
                        <span className="text-muted small">
                          ({formatBytes(f.FILE_SIZE)})
                        </span>
                      )}
                    </div>

                    {f.url && (
                      <a
                        className="btn btn-sm btn-outline-secondary"
                        href={f.url}
                        target="_blank"
                        rel="noreferrer"
                        download={f.FILE_NM}
                      >
                        <i className="fa-regular fa-download me-1" />
                        다운로드
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <div className="form-control bg-light text-muted">
                첨부파일이 없습니다.
              </div>
            )}
          </div>

          {/* 원본 컬럼 전체 표출 (이미지에 보인 필드들) */}
            <div className="col-12 mt-2">
              <label className="form-label">표시 / 배치 설정</label>

              {/* 창 형태 + 노출/사용 */}
              <div className="row g-2 mb-2">
                <div className="col-md-4">
                  <label className="form-label mb-1">창 형태</label>
                    {edit ? (
                      <select
                        className="form-select"
                        value={form.WIN_STYLE || ""}
                        onChange={(e) => set("WIN_STYLE", e.target.value)}
                      >
                        <option value="">레이어 팝업</option>
                        <option value="W">새창(윈도우 팝업)</option>
                      </select>
                    ) : (
                      <input className="form-control" value={(form.WIN_STYLE || "") === "W" ? "새창" : "레이어"} disabled />
                    )}
                </div>

                <div className="col-md-4">
                  <label className="form-label mb-1">노출 여부</label>
                  {edit ? (
                    <div className="form-check form-switch mt-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={(form.VIEW_YN || "Y") === "Y"}
                        onChange={(e) => set("VIEW_YN", e.target.checked ? "Y" : "N")}
                      />
                      <span className="ms-2">{(form.VIEW_YN || "Y") === "Y" ? "ON" : "OFF"}</span>
                    </div>
                  ) : (
                    <input className="form-control" value={(form.VIEW_YN || "N") === "Y" ? "ON" : "OFF"} disabled />
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label mb-1">사용 여부</label>
                  {edit ? (
                    <div className="form-check form-switch mt-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={(form.USE_AT || "Y") === "Y"}
                        onChange={(e) => set("USE_AT", e.target.checked ? "Y" : "N")}
                      />
                      <span className="ms-2">{(form.USE_AT || "Y") === "Y" ? "사용" : "미사용"}</span>
                    </div>
                  ) : (
                    <input className="form-control" value={(form.USE_AT || "N") === "Y" ? "사용" : "미사용"} disabled />
                  )}
                </div>
              </div>

              {/* 위치/크기 */}
              <div className="row g-2">
                <div className="col-6 col-md-3">
                  <label className="form-label mb-1">가로 위치 (px)</label>
                  {edit ? (
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      value={form.POS_LEFT ?? 0}
                      onChange={(e) => set("POS_LEFT", Math.max(0, Number(e.target.value || 0)))}
                    />
                  ) : (
                    <input className="form-control" value={form.POS_LEFT ?? 0} disabled />
                  )}
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label mb-1">세로 위치 (px)</label>
                  {edit ? (
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      value={form.POS_TOP ?? 0}
                      onChange={(e) => set("POS_TOP", Math.max(0, Number(e.target.value || 0)))}
                    />
                  ) : (
                    <input className="form-control" value={form.POS_TOP ?? 0} disabled />
                  )}
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label mb-1">너비 (px)</label>
                  {edit ? (
                    <input
                      type="number"
                      min={240}
                      className="form-control"
                      value={form.SIZE_WIDTH ?? 500}
                      onChange={(e) => set("SIZE_WIDTH", Math.max(240, Number(e.target.value || 0)))}
                    />
                  ) : (
                    <input className="form-control" value={form.SIZE_WIDTH ?? 500} disabled />
                  )}
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label mb-1">높이 (px)</label>
                  {edit ? (
                    <input
                      type="number"
                      min={200}
                      className="form-control"
                      value={form.SIZE_HEIGHT ?? 580}
                      onChange={(e) => set("SIZE_HEIGHT", Math.max(200, Number(e.target.value || 0)))}
                    />
                  ) : (
                    <input className="form-control" value={form.SIZE_HEIGHT ?? 580} disabled />
                  )}
                </div>
              </div>
            </div>
        </div>
      </div>

      {/* 상세창 안에서 뜨는 삭제 모달 */}
      <ConfirmModal
        show={askDelete}
        title="삭제 확인"
        message={`"${form?.NTT_SJ || "이 글"}"을 삭제하시겠습니까?`}
        onCancel={() => setAskDelete(false)}
        onConfirm={async () => {
          await deletePopup({ ...form, ID: item?._SRC?.ID ?? form.ID, CONT_ID: item?._SRC?.CONT_ID ?? form.CONT_ID });
          setAskDelete(false);
          onClose?.();
        }}
        portalTarget={portalTarget}
      />
    </div>
  );
}

/* =========================
   메인: PopupMgr
========================= */
export default function PopupMgr() {
  const [detail, setDetail] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);

  // 🔎 검색필터 (등록일 범위 + 제목)
  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
    keyword: "",
  });
  const [draft, setDraft] = useState({
    dateFrom: "",
    dateTo: "",
    keyword: "",
  });
  const onSearch = () => setFilters({ ...draft });

  // API 데이터
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const popups = async () => {
    try {
      setError(null);
      setItems(null);
      setLoading(true);

      const url = "/scms/api/pop/selectPopList.do";
      const body = JSON.stringify({});
      apiAxios(url, body, function (res) {
        if (res.apiRes === "Y") {
          setItems(res.list || []);
        } else {
          console.error(res.message);
          setError(new Error(res.message || "API Error"));
        }
        setLoading(false);
      });
    } catch (e) {
      setError(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    popups();
  }, []);

  // API 결과 → 화면 rows로 정규화 (모든 키 UPPERCASE)
  const rows = useMemo(() => {
    if (!Array.isArray(items)) return [];

    const YN = (v, d = "N") =>
      String(v ?? d).trim().toUpperCase() === "Y" ? "Y" : "N";
    const UP = (v) => String(v ?? "").trim().toUpperCase();
    const NUM = (v, d = 0) => {
      const m = String(v ?? "").match(/-?\d+(\.\d+)?/);
      const n = m ? Number(m[0]) : NaN;
      return Number.isFinite(n) ? n : d;
    };

    return items.map((p, idx) => {
      const TITLE = p.PMG_NM ?? p.TITLE ?? "";
      const CONTENT_HTML = p.PMG_CN ?? p.CONTENT ?? "";
      const CONT_ID = p.CONT_ID ?? p.ID ?? `${idx + 1}`;

      const WIN_STYLE = UP(p.WIN_STYLE);   // "W"=새창, 그 외=레이어
      const VIEW_YN   = YN(p.VIEW_YN, "Y");
      const USE_AT    = YN(p.USE_AT,  "Y");

      const SIZE_WIDTH  = NUM(p.SIZE_WIDTH,  POPUP_POLICY.DEFAULT_WIDTH);
      const SIZE_HEIGHT = NUM(p.SIZE_HEIGHT, POPUP_POLICY.DEFAULT_HEIGHT);
      const POS_LEFT    = NUM(p.POS_LEFT,  0);
      const POS_TOP     = NUM(p.POS_TOP,   0);

      const START = (p.VIEW_ST ?? "").toString().slice(0, 10);
      const END   = (p.VIEW_ED ?? "").toString().slice(0, 10);

      return {
        NO: idx + 1,
        ID: CONT_ID,
        CONT_ID,
        TITLE,
        CONTENT_HTML,
        CONTENT_TEXT: stripHtml(CONTENT_HTML),
        THUMB: p.THUMB ?? firstImgSrc(CONTENT_HTML),
        USER: p.USER_NM ?? p.USER_ID ?? "-",
        START,
        END,
        REG_DT: p.FRST_PNTTM ?? p.REG_DT ?? "",

        // 표시/배치(등록/상세와 동일 키로 UPPERCASE)
        WIN_STYLE,
        VIEW_YN,
        USE_AT,
        POS_LEFT,
        POS_TOP,
        SIZE_WIDTH,
        SIZE_HEIGHT,

        // 테이블 표기용 라벨
        WIN_STYLE_LABEL: WIN_STYLE === "W" ? "새창" : "레이어",
        VIEW_LABEL: VIEW_YN === "Y" ? "ON" : "OFF",
        USE_LABEL: USE_AT === "Y" ? "사용" : "미사용",

        // 원본(그대로 유지)
        _SRC: p,
      };
    });
  }, [items]);


  // 기존 규칙 유지: 제목으로만 검색, 날짜는 start 기준
  const filtered = useMemo(() => {
    return rows.filter((r) => {
      const ymd = (r.START || "").slice(0, 10);
      if (
        filters.keyword &&
        !(r.TITLE || "")
          .toLowerCase()
          .includes(filters.keyword.toLowerCase())
      )
        return false;
      if (filters.dateFrom && ymd < filters.dateFrom) return false;
      if (filters.dateTo && ymd > filters.dateTo) return false;
      return true;
    });
  }, [rows, filters]);

  if (loading) return <div> Loading... </div>;
  if (error) return <div> 에러가 발생했습니다. </div>;
  if (!items) return null;

  const openNew = () => setDetail({});
  const openDetail = (row) => setDetail(row);

  return (
    <div className="cms-card">
      {/* 🔎 검색 필터 박스 (등록일, 제목 + 우측 조회/등록) */}
      <div className="cms-card mb-3 filterBox">
        <div className="row g-2 align-items-end input-rounded">
          <div className="col-md-3 col-6">
            <label className="form-label mb-1">등록일(시작)</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={draft.dateFrom}
              onChange={(e) =>
                setDraft({ ...draft, dateFrom: e.target.value })
              }
            />
          </div>
          <div className="col-md-3 col-6">
            <label className="form-label mb-1">등록일(끝)</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={draft.dateTo}
              onChange={(e) => setDraft({ ...draft, dateTo: e.target.value })}
            />
          </div>
          <div className="col-md-4 col-8">
            <label className="form-label mb-1">제목</label>
            <input
              className="form-control form-control-sm"
              placeholder="제목으로 검색"
              value={draft.keyword}
              onChange={(e) => setDraft({ ...draft, keyword: e.target.value })}
              onKeyDown={(e) => e.key === "Enter" && onSearch()}
            />
          </div>
          <div className="col-md-2 col-4">
            <div className="d-flex gap-2 justify-content-end">
              <button className="btn btn-sm btn-primary" onClick={onSearch}>
                조회
              </button>
              <button className="btn btn-sm btn-outline-primary" onClick={openNew}>
                <i className="fa-solid fa-plus me-1"></i>등록
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* 📋 리스트 (번호/썸네일/제목/팝업내용/등록자/기간) */}
      <table className="table table-hover table-rounded">
        <thead>
          <tr>
            <th style={{ width: 70 }}>번호</th>
            <th style={{ width: 130 }}>썸네일</th>
            <th style={{ minWidth: 240 }}>제목</th>
            {/* <th>팝업내용</th> */}
            <th style={{ width: 140 }}>등록자</th>
            <th style={{ width: 220 }}>기간</th>
            <th style={{ width: 120 }}></th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((r) => (
            <tr
              key={r.ID}
              style={{ cursor: "pointer" }}
              onClick={() => openDetail(r)}
            >
              <td>{r.NO}</td>
              <td>
                <ThumbPreview
                  thumb={r.THUMB}
                  title={r.TITLE}
                  content={r.CONTENT_HTML}
                />
              </td>
              <td className="text-truncate" title={r.TITLE}>
                {r.TITLE}
              </td>
              {/* <td className="text-truncate" title={r.contentText}>
                {r.contentText}
              </td> */}
              <td>{r.USER}</td>
              <td className="text-muted small">
                {r.START || "-"} ~ {r.END || "-"}
              </td>
              {/* ▼ 액션: 클릭 버블 막기 + 버튼 그룹/스타일 완전 동일 */}
              <td className="text-end" onClick={(e) => e.stopPropagation()}>
                <div className="btn-group btn-group-sm">
                  <button className="btn btn-outline-secondary" onClick={() => openDetail(r)}>
                    <i className="fa-regular fa-eye"></i>
                  </button>
                  <button className="btn btn-outline-danger" onClick={() => setConfirmDel(r)}>
                    <i className="fa-regular fa-trash-can"></i>
                  </button>
                </div>
              </td>
            </tr>
          ))}
          {!filtered.length && (
            <tr>
              <td colSpan={6} className="text-center text-muted py-5">
                데이터가 없습니다.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* 상세창 */}
      {detail && (
        <NewWindow
          title={detail?.ID ? "팝업 상세" : "팝업 등록"}
          onClose={() => setDetail(null)}
        >
          {(portalTarget) => (
            <DetailPanel
              item={detail?.ID ? detail : null}
              onClose={() => setDetail(null)}
              onSaved={() => { setDetail(null); popups(); }}
              onDeleted={() => setDetail(null)}
              portalTarget={portalTarget}
            />
          )}
        </NewWindow>
      )}

      {/* 목록에서 바로 삭제(보기/삭제 버튼 중 '삭제') */}
      <ConfirmModal
        show={!!confirmDel}
        title="삭제 확인"
        message={`"${confirmDel?.TITLE || confirmDel?._SRC?.PMG_NM || "이 항목"}"을 삭제하시겠습니까?`}
        onCancel={() => setConfirmDel(null)}
        onConfirm={async () => {
          const ok = await deletePopup(confirmDel);   // ← 성공여부 받음
          setConfirmDel(null);
          if (ok) popups();   // ← 성공시에만 리스트 재조회
        }}
      />
    </div>
  );
}
